import React, { FC } from 'react';
import { Roof } from 'src/components/Roof';

interface Props {}

export const RoofPage: FC<Props> = () => (
  <Roof />
);
